/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BookmarkSmallOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Bookmark Small Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22 8v17.914l-3.58-3.5-1.4-1.364-1.4 1.36L12 25.944V8h10m1-2H11a1 1 0 0 0-1 1v22.506a.523.523 0 0 0 .306.456.421.421 0 0 0 .2.044.511.511 0 0 0 .352-.148l6.174-6.01 6.122 5.988a.5.5 0 0 0 .352.144.472.472 0 0 0 .2-.038.5.5 0 0 0 .294-.454V7a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
